import { renameLegacyQuery } from '~/libs/legacyQuery'

// Pages parse the query through zod schemas that only know the new names, so rename before they run.
export default defineNuxtRouteMiddleware(to => {
  const query = renameLegacyQuery(to.query)
  if (!query) return
  return navigateTo({ path: to.path, query, hash: to.hash }, { redirectCode: 301, replace: true })
})
